import React from 'react';
import { Hero } from './components/Hero';
import { TestimonialsTop, TestimonialsMore } from './components/Testimonials';
import { Pain } from './components/Pain';
import { Product } from './components/Product';
import { Bonuses } from './components/Bonuses';
import { Countdown } from './components/Countdown';
import { Pricing } from './components/Pricing';
import { ComparisonAI } from './components/ComparisonAI';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { CostOfInaction } from './components/CostOfInaction';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { StickyCTA } from './components/StickyCTA';
export function App() {
  return <div className="w-full bg-white font-sans text-slate-900" data-id="element-0" data-mp="2wip5x1c7ng4e">
      <main className="w-full" data-id="element-1" data-mp="28tme50nv46w6">
        <Hero data-id="element-2" data-mp="28sl32w6ujkeg" />
        <TestimonialsTop data-id="element-3" data-mp="28sbad0uf2z52" />
        <Pain data-id="element-4" data-mp="23vkuoemiy5k6" />
        <Product data-id="element-5" data-mp="23w4gi6fape3h" />
        <Bonuses data-id="element-6" data-mp="23ujk0b9f7l2z" />
        <Countdown data-id="element-7" data-mp="23v2s7099qv3t" />
        <Pricing data-id="element-8" data-mp="23ti7e2craqj5" />
        <ComparisonAI data-id="element-9" data-mp="3ik7fce9tu7pl" />
        <TestimonialsMore data-id="element-10" data-mp="3ikqwhsrnks2k" />
        <Guarantee data-id="element-11" data-mp="3ijfthv617oci" />
        <FAQ data-id="element-12" data-mp="3ii4t85bsoyq5" />
        <CostOfInaction data-id="element-13" data-mp="3mlj98vzqhf3l" />
        <FinalCTA data-id="element-14" data-mp="3mkrefndynled" />
      </main>
      <Footer data-id="element-15" data-mp="3mjztr7lwj82v" />
      <StickyCTA data-id="element-16" data-mp="3mjga9mglsbmq" />
    </div>;
}